'use client';

import ModelBeginPage from '../ModelBeginPage';
import ModelStepOnePage from '../ModelStepOnePage';
import ModelStepTwoFloorplanPage from '../ModelStepTwoFloorplanPage';
import qs from 'qs';
import { useRouter } from 'next/router';

const BuildPriceSeriesPages = (props) => {
    const router = useRouter();
    const qsData = qs.parse((router.asPath.split('?')[1] || ''));
    const keys = Object.keys(qsData).map(k => k.toLowerCase());
    const isVariant = keys.some(k => k.includes('variant'));
    const isFloorplan = !isVariant && keys.some(k => k.includes('floorplan'));
    const isDefault = !isVariant && !isFloorplan;

    return (<>
        {isDefault ?
            <ModelBeginPage 
                {...props}
            />
        : isVariant ?
            <ModelStepOnePage 
                {...props}
            />
        : isFloorplan &&
            <ModelStepTwoFloorplanPage
                {...props}
            />
        }
            
        
    </>);
}

BuildPriceSeriesPages.propTypes = {
    // Component props defined here
}

export default BuildPriceSeriesPages
